export default "__VITE_ASSET__8d28b05a__"